import graphqlClient from "../../../apollo";

class SalesReportProvider {

    salesReport(date, branch, filters) {
        return graphqlClient.query({
            query: require('./gql/SalesReport/salesReport.graphql'),
            variables: {date, branch, filters},
            fetchPolicy: "network-only"
        })
    }

    deliveryCostReport(date, branch, filters) {
        return graphqlClient.query({
            query: require('./gql/SalesReport/deliveryCostReport.graphql'),
            variables: {date, branch, filters},
            fetchPolicy: "network-only"
        })
    }
}

export default new SalesReportProvider()


